import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/ott-platform/add-ons.jpg'


const _hoisted_1 = { class: "ott-add-ons-area ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6 col-md-12",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "300"
}
const _hoisted_5 = { class: "ott-add-ons-content" }
const _hoisted_6 = {
  class: "accordion",
  id: "accordionOns"
}
const _hoisted_7 = { class: "accordion-header" }
const _hoisted_8 = ["aria-expanded", "onClick"]
const _hoisted_9 = { class: "accordion-collapse collapse show" }
const _hoisted_10 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "section-title mw-526 m-auto text-center",
        "data-aos": "fade-up",
        "data-aos-duration": "1000",
        "data-aos-delay": "100"
      }, [
        _createElementVNode("h2", { class: "text-white" }, "خصّص تجربتك مع ميزاتنا الإضافية")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "col-lg-6 col-md-12",
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": "200"
        }, [
          _createElementVNode("div", { class: "ott-add-ons-image" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "image"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addons, (addon, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["accordion-item", { active: _ctx.activeIndex === index }])
                }, [
                  _createElementVNode("h2", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "accordion-button",
                      type: "button",
                      "aria-expanded": _ctx.activeIndex === index ? 'true' : 'false',
                      onClick: ($event: any) => (_ctx.toggleAccordion(index))
                    }, _toDisplayString(addon.title), 9, _hoisted_8)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(addon.description), 1)
                    ])
                  ], 512), [
                    [_vShow, _ctx.activeIndex === index]
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}